export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Dental Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, simulation lab or clinic.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for dental instructors, clinical faculty, dental school educators, dental assisting and dental hygiene program instructors and continuing-education trainers. Adjust the content to your students, your level and your own curriculum.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each session to your students.',
    ],
  },
  {
    q: 'Does it work for dental assisting and hygiene programs as well as dental schools?',
    a: [
      'Yes. The material covers anatomy, diagnosis and radiology, restorative dentistry, endodontics, periodontics, oral surgery, local anesthesia and clinical teaching methods, so it works for dental school courses, dental assisting and hygiene programs and continuing-education workshops alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or labeled diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct technique comparison, a teaching cue, a drill and a quick check. The five bonuses add practical teaching tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, demonstration guides, simulation drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Dental anatomy, oral histology and tooth morphology; oral pathology, dental radiology and clinical diagnosis; restorative dentistry, dental materials and operative techniques; endodontics, periodontics and clinical treatment procedures; oral surgery, local anesthesia and patient management; and dental clinical instruction, teaching programs and practical assessments.',
    ],
  },
  {
    q: 'Does it replace accredited dental education or clinical guidelines?',
    a: [
      'No. This is educational teaching-support material for instructors. It does not replace an accredited dental curriculum, professional licensing requirements, current clinical guidelines, local regulations or qualified clinical supervision. Always follow your institution’s protocols, especially for local anesthesia, radiography and surgical procedures.',
      'Results depend on each instructor, student and training context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual dentistry teaching and clinical training volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience, with Universal and FDI tooth numbering.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
